<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <textarea
        id="form-element-{{ formField.id }}"
        class="form-control"
        name="formField{{ formField.id }}"
        appWhitespaceValidator
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        [placeholder]="formField.placeholder"
        [required]="formField.isRequired"
        [(ngModel)]="formField.value"
        [needToCheck]="formField.isRequired">
    </textarea>
    @if (formService.isSubmitted && formField.isRequired && !formField.value?.trim()) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
